<template>
  <div class="filter">
    <div class="label-title mb-3">
      {{ $t('view-Search.filter-title.age') }}
    </div>
    <div>
      <range-input
        v-model="age"
        :min="13"
        :max="90"
        :marks="[13, 30, 50, 70, 90]"
        :contained="true"
        tooltip="always"
        :dot-size="16"
      />
    </div>
  </div>
</template>

<script>
import '../../../assets/scss/vue-slider.scss'
import VueSlider from 'vue-slider-component'

export default {
  components: {
    'range-input': VueSlider
  },
  props: {
    value: {
      type: [Number, Array],
      default: null
    }
  },
  computed: {
    age: {
      get () {
        return [this.value[0] || 13, this.value[1] || 90]
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
